import { CancellablePromise } from '../../types/cancellable-promise';

import { SLMap } from '../sl-map';
import { LayerRenderResult } from '../../types/layerrenderresult';
import { EventEmitter, Output, OnInit } from '@angular/core';
import { SLLayer, LayerTypeEnum } from '../sl-layer';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { ResultsService } from 'src/app/services/results.service';
import { IClearable } from 'src/app/types/iclearable';
import { ISelectionData, ISelectionInfo } from '../synchronizer';
import { MapDataAction } from '../map-actions/map_data-action';
import { ColorClass } from 'src/app/types/color-class';



export class SelectedResultsLayer extends SLLayer implements IClearable {
	public sourceLayer: SLLayer;
	private features: Array<any>;
	private subs: Array<SLLayer> = [];
	private vis = false;
	private labelVis = true;
	private selections: ISelectionInfo;

	public inheritLabels = true;
	public myOpacity = 1;
	public labelInfo: any = {
		labelField: '_sl_inherit_',
		labelStyleJSON: {
			font: 'RobotoBlack', size: 12, color: '#ffffff',
			align: 'center', outlinecolor: '#000000', outlinewidth: 2, shadowcolor: '#ededed',
			shadowsizex: 0, shadowsizey: 5, offsetx: 0, offsety: 20, position: 'lc'
		},
		inheritLabelStyle: true,
		inheritOnly: true,
		labelOverride: '',
		override: false,
		labelsOn: true
	};

	iconChange: EventEmitter<string> = new EventEmitter<string>();

	GetColor() {
		return this.map.styles.selected;
	}

	public get classification(): Array<ColorClass> {
		this.MakeClassificaiton();
		return this._classification;
	}
	get layerOn(): boolean {
		if (this.parentSLLayer.layerOn === false) {
			return false;
		}
		return this.vis;
	}
	set layerOn(isVis: boolean) {

		this.vis = isVis;
		if (isVis && this.touched) {
			this.Render(this.SLMap);
			this.touched = false;
		} else {
			if (this.overlayLayer === undefined) {
				this.Render(this.SLMap);
			} else {
				try {
					this.overlayLayer.UpdateVisibility();
					// map.ui.getLayer(this.overlayLayer.id);
					// map.ui.setLayoutProperty(this.overlayLayer.ui.id, 'visibility', (isOn && this.parentVis) ? 'visible' : 'none');
				} catch (e) {
					// this.Render(map);
					// do nothign;
				}
			}
		}
		this.visChange.emit({ layer: this });
	}

	SetLayerOn(isVis: boolean, map: SLMap = null) {
		map = map;
		this.layerOn = isVis;
	}

	get labelsOn(): boolean {
		if (!this.parentSLLayer.labelsOn) {
			return false;
		}

		return this.labelVis;

	}
	set labelsOn(isVis: boolean) {
		this.labelVis = isVis;
	}
	get srcLabelsOn(): boolean {
		if (this.sourceLayer) {
			return this.sourceLayer.labelsOn;
		}
		return false;
	}

	get opacity(): number {
		if (!!this.myOpacity) {
			return this.myOpacity;
		} else {
			return 0;
		}
	}
	set opacity(level: number) {
		this.myOpacity = level;
		this.overlayLayer.UpdateOpacity();
		this.change$.emit(this);

	}


	get queryAble(): boolean {
		if (this.searchable === false) {
			return false;
		}
		return [
			LayerTypeEnum.Vector.valueOf(),
			LayerTypeEnum.Relational.valueOf()
		].indexOf(+this.type) > -1;
		// return (this.access >= LayerAccessLevel.Read);
	}

	get parentLayer(): string {
		return 'results';
	}

	get searchable(): boolean {
		if ([
			LayerTypeEnum.Vector.valueOf(),
			LayerTypeEnum.Relational.valueOf()
		].indexOf(+this.type) === -1) {
			return false;
		}
		return this.data.search_on === 1;
	}

	set searchable(isSearchable: boolean) {
		this.data.search_on = isSearchable === true ? 1 : 0;
	}

	constructor(map: ISLMap, resultsSvc: ResultsService) {
		super(null, map, null, null, resultsSvc);
		this.myOpacity = 1;
		// const me = this;
		this.abilities.include_in_legend = true;

	}
	SetSelections(data: ISelectionData) {
		const sameLayer = !!this.selections && this.selections?.layer && this.sourceLayer && (data.selections?.layer === this.sourceLayer);
		const hadFeatures = (!!this.selections && !!this.selections?.features && this.selections?.features.length > 0);
		const hasFeatures = data.selections?.features?.length > 0;
		this.selections = data.selections;
		this.ShowOrHide();
		if (!this.enabled) {
			this.Clear();
		} else {
			this.Render();
		}
		if (!sameLayer || (hasFeatures && !hadFeatures)) {
			this.UpdateLegend();
		}
		MapDataAction.UpdateLayerPropertyView(this);
	}
	ShowOrHide() {
		if (!this.selections) {
			this.enabled = false;
			this.layerOn = false;
			this.layerOn = this.enabled;
			return;
		}
		if (!!this.selections.layer) {
			this.sourceLayer = this.selections.layer;
			this.data = this.sourceLayer.CloneData();
			this.icon = this.icon;
			if (!!this.selections.features) {
				if (this.selections.features.length > 0) {
					this.enabled = true;
					this.layerOn = true;
					return;
				}
			}
		}
		this.enabled = false;
		this.layerOn = false;


	}
	ShowResults(layer: SLLayer, features: Array<any>, styles: any) {
		layer = features = styles = null;
		/*this.sourceLayer = layer;
		this.data = layer.CloneData();
		this.enabled = features.length > 0;
		this.features = features;
		this.styles = styles;
		this.layerOn = this.enabled;
		this.labelVis = this.sourceLayer.labelsOn;
		this.labelAttribute = this.sourceLayer.labelAttribute;
		if (this.labelAttribute === 'default') {
			if (!!this.layerAttributes) {
				if (!!this.layerAttributes.length) {
					if (this.layerAttributes.length > 0) {
						this.labelAttribute = this.layerAttributes[0].name;
					}
				}
			}

		}
		if (!this.enabled) {
			this.Clear();
		} else {
			this.Render(null);
		}
		*/
	}

	Clear() {
		this.features = [];
		this.overlayLayer.Clear();
		this.vis = false;
		this.enabled = false;

	}

	get overlayId(): string {
		return this.overlayLayer.id;
	}

	get defaultCriteria(): Array<any> | null {
		if (this.isPLayer === false) {
			return null;
		}
		return this.data.criteria;
	}
	get description(): string {
		return 'Selected results from: ' + this.sourceLayer.name;
	}
	set description(desc: string) {
		desc = null;
		return;
	}

	get id(): string {
		return 'sel-results';
	}

	get icon(): string {
		if (!!this.sourceLayer) {
			return this.sourceLayer.icon;
		}
		return '';
	}
	set icon(val: string) {
		val = val;
		this.iconChange.emit(this.icon);
	}



	get renderId() {
		return this.sourceLayer.identifier;
	}

	get plid(): string {
		return 'sel-results';
	}
	get name(): string {
		return 'Selected Results';
	}
	set name(name: string) {
		name = name;
		return;
	}
	get geom(): string {
		if (!!this.data) {
			return this.data.geom;
		}
		return '';
	}
	get searchtip(): string {
		return (this.data.searchtip === null) ? '' : this.data.searchtip;
	}
	set searchTip(tip: string) {
		this.data.searchTip = (tip === '') ? null : tip;
	}

	get type(): number {
		return LayerTypeEnum.Virtual_SelectedResults;
	}
	set type(layerType: number) {
		layerType = layerType;
	}
	get typeString(): string {
		return LayerTypeEnum[LayerTypeEnum.Virtual_SelectedResults];
	}
	get identifier() {
		if (this.isPLayer === true) {
			return this.plid;
		}
		return this.id;
	}

	get subLayers(): Array<any> {
		return [];

	}
	get subSLLayers(): Array<SLLayer> {
		return [];
	}
	get hasSubLayers(): boolean {
		return false;
	}

	Render(map: ISLMap = null, force: boolean = false) {
		if (force === true) {
			this.touched = true;
		}
		if (!this.layerOn && !this.touched && !this.parentVis) {
			return;
		}
		if (this.sourceLayer === undefined) {
			return;
		}
		if (map === null) {
			if (this.SLMap === undefined) {
				return;
			}
			map = this.SLMap;
		}

		if (this.isPLayer) {
			if (this.layerOn === false || this.enabled === false) {
				this.Clear();
				this.touched = true;
				this.rendered.emit({ id: this.identifier, isPLayer: this.isPLayer, status: 'ok' });
				return;
			}
		}
		this.rendering.emit({ id: this.identifier, isPLayer: this.isPLayer });
		const handler = (result: LayerRenderResult) => {
			if (result === undefined) {
				this.Clear();
				this.rendered.emit({
					id: this.identifier,
					isPLayer: this.isPLayer,
					status: 'problem',
					error: 'There was a problem retrieving layer :' + this.name
				});
				return;
			}
			this.overlayLayer.HandleRenderResult(result);

		};
		this.styles.unormal = '1';
		let labelsOn = this.labelsOn;
		let labelStyle = this.labelStyle;
		let labelValue = this.sourceLayer.labelOverride;
		if (this.labelInfo.override === true) {
			// labelsOn = this.labelInfo.labelsOn;
			labelStyle = this.labelInfo.labelStyleJSON;
			labelValue = this.labelInfo.labelOverride;
			this.labelAttribute = this.labelInfo.labelField;
		}
		if (this.isPLayer === true) {
			const styles = JSON.parse(JSON.stringify(this.styles));
			delete styles.unselected;
			this.SLMap.component.layerAPI.RenderProjectLayerById(
				this,
				map,
				this.selections.features,
				styles, labelsOn, undefined, JSON.stringify(labelStyle), labelValue).then(handler);
			return;
		}

		const promise: CancellablePromise | void = this.SLMap.component.layerAPI.RenderLayerById(
			this.sourceLayer.identifier,
			map,
			this.selections.features,
			this.styles,
			labelsOn, JSON.stringify(labelStyle));
		if (promise) {
			promise.then(handler);
		}
	}

	GetFeatures(): Array<any> {
		return this.selections.features;
	}
	HasFeatures(): boolean {
		if (!this.selections) {
			return false;
		}
		if (!this.selections.features) {
			return false;
		}
		return this.selections.features.length > 0;
	}
	ZoomToFeatures() {
		this.SLMap.component.HandleToolAction({
			action: 'info/zoom-to-features',
			layer: this.sourceLayer.id,
			features: this.features.join(',')
		});
	}

	/*ngOnInit() {
		this.subs = this.subs;
	}*/
	SetLabelInfo(info: any) {
		this.labelInfo = info;
		this.labelsOn = info.labelsOn;
	}
	GetLabelInfo() {
		return this.labelInfo;
	}
	IsVirtual() {
		return true;
	}
	MakeClassificaiton() {
		const style = this.map.styles.selected;
		const styleSections = style.split(';');

		let strokeHex = Math.round(Number(styleSections[2]) * 255).toString(16);
		if (strokeHex.length === 1) {
			strokeHex = '0' + strokeHex;
		}
		let fillHex = Math.round(Number(styleSections[1]) * 255).toString(16);
		if (fillHex.length === 1) {
			fillHex = '0' + fillHex;
		}
		const hasStroke = Number(styleSections[2]) > 0;
		let stroke = hasStroke ? styleSections[0] : 'trans';
		stroke = stroke === 'trans' ? 'trans' : stroke;// + strokeHex;
		const hasFill = Number(styleSections[1]) > 0;
		let fill = hasFill ? styleSections[0] : 'trans';
		fill = fill === 'trans' ? 'trans' : fill;// + fillHex;

		this._classification = [
			{
				crid: -1,
				criteria1: 'gid',
				criteria2: '>',
				criteria3: 0,
				description: 'Selected Geometry',
				priority: 1,
				useFill: false,
				fill: 'trans',
				fillOpacity: 0,
				useStroke: hasStroke,
				stroke: (stroke),
				strokeOpacity: Number(styleSections[2]),
				field: '',
				operator: '',
				value: '',
				symbol: 'default',
				size: 4,
				useLabelStyle: this.labelsOn,
				labelStyle: this.labelStyle
			}, {
				crid: -2,
				criteria1: 'gid',
				criteria2: '>',
				criteria3: 0,
				description: 'Selected Geometry',
				priority: 2,
				useFill: hasFill,
				fill: (fill),
				fillOpacity: Number(styleSections[1]),
				useStroke: false,
				stroke: 'trans',
				strokeOpacity: 0,
				field: '',
				operator: '',
				value: '',
				symbol: 'default',
				size: 4,
				useLabelStyle: false,
				labelStyle: ''
			}
		];
	}
	GetSourceLayer() {
		return this.sourceLayer;
	}
}

